import { FeatureFlag } from '../FeatureFlag';

export const systemMessage = new FeatureFlag({
    key: 'system-message',
    defaultValue: '',
});
